$(document).ready(function() {
    const accordion = document.getElementById('intro-accordion');
    const readMoreAnchor = document.getElementById('intro-read-more');
    const readMoreAnchorText = document.querySelector('#intro-read-more p');

    let readingMore = 0;
    if (readMoreAnchor) {
        readMoreAnchor.addEventListener('click', e => {
            UIkit.accordion(accordion).toggle(1, true);
            readingMore = !readingMore;
            if (readingMore) {
                readMoreAnchorText.style.transition = 'opacity .25s ease-in-out';
                readMoreAnchorText.style.opacity = '0';
                setTimeout(function () {
                    readMoreAnchorText.innerHTML = 'Show Less';
                    readMoreAnchorText.style.opacity = '1';
                }, 250);
            }
            else {
                readMoreAnchorText.style.opacity = '0';
                setTimeout(function () {
                    readMoreAnchorText.innerHTML = 'Read More';
                    readMoreAnchorText.style.opacity = '1';
                }, 250);
            }
        });
    }
});